export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Nombres',
                    type: 'text',
                    key: 'full_name',

                },
                {
                    title: 'Nombre de Usuario',
                    type: 'text',
                    key: 'username',

                },
                {
                    title: 'Identificación',
                    type: 'text',
                    key: 'taxid',

                },
                {
                    title: 'Correo electrónico',
                    type: 'text',
                    key: 'email',

                },
                {
                    title: 'Area',
                    type: 'custom-html',
                    key: 'area',
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            return value.name;
                        }
                    }
                },
                {
                    title: 'Cargo',
                    type: 'custom-html',
                    key: 'position',
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            return value.name;
                        }
                    }
                },
                {
                    title: 'Rol',
                    type: 'custom-html',
                    key: 'roles',
                    isVisible: true,
                    modifier: (value) => {
                        let rolesName = '';
                        if (value.length > 0) {
                            value.forEach(element => {
                                rolesName = rolesName + ' ' +element.name + ' -';
                            });
                            return rolesName.slice(0, -1);
                        }else{
                            return 'N/A';
                        }
                    }
                }
            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}